import DOMPurify from 'dompurify';
const containsHTML = (text) => {
    return /<[a-z][\s\S]*>/i.test(text);
  };

  const truncateTextByLines = (text, lineLimit, lineHeight = 1.2) => {
    if (containsHTML(text)) {
      // إذا كان النص يحتوي على HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = text;
      tempDiv.style.position = 'absolute';
      tempDiv.style.visibility = 'hidden';
      tempDiv.style.width = '100%'; // افتراض عرض كامل
      document.body.appendChild(tempDiv);
      
      const contentHeight = tempDiv.offsetHeight;
      const estimatedLines = Math.ceil(contentHeight / (parseInt(getComputedStyle(tempDiv).fontSize) * lineHeight));
      
      let truncatedContent = text;
      if (estimatedLines > lineLimit) {
        // البحث عن النقطة المناسبة للقص بناءً على عدد السطور
        const words = tempDiv.textContent.split(' ');
        let currentText = '';
        let currentLines = 0;
        
        for (let i = 0; i < words.length; i++) {
          currentText += words[i] + ' ';
          tempDiv.textContent = currentText + '...';
          currentLines = Math.ceil(tempDiv.offsetHeight / (parseInt(getComputedStyle(tempDiv).fontSize) * lineHeight));
          
          if (currentLines >= lineLimit) {
            truncatedContent = currentText + '...';
            break;
          }
        }
      }
      
      document.body.removeChild(tempDiv);
      return truncatedContent;
    } else {
      // إذا كان النص عاديًا
      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'absolute';
      tempDiv.style.visibility = 'hidden';
      tempDiv.style.width = '100%'; // افتراض عرض كامل
      tempDiv.textContent = text;
      document.body.appendChild(tempDiv);
      
      const contentHeight = tempDiv.offsetHeight;
      const fontSize = parseInt(getComputedStyle(tempDiv).fontSize);
      const estimatedLines = Math.ceil(contentHeight / (fontSize * lineHeight));
      
      let truncatedText = text;
      if (estimatedLines > lineLimit) {
        const words = text.split(' ');
        let currentText = '';
        let currentLines = 0;
        
        for (let i = 0; i < words.length; i++) {
          currentText += words[i] + ' ';
          tempDiv.textContent = currentText + '...';
          currentLines = Math.ceil(tempDiv.offsetHeight / (fontSize * lineHeight));
          
          if (currentLines >= lineLimit) {
            truncatedText = currentText + '...';
            break;
          }
        }
      }
      
      document.body.removeChild(tempDiv);
      return truncatedText;
    }
  };
    const truncateText = (text, wordLimit) => {
    if (containsHTML(text)) {

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = text;
      let words = tempDiv.textContent.split(' ');
      if (words.length > wordLimit) {
        words = words.slice(0, wordLimit);
        tempDiv.textContent = words.join(' ') + '...';
      }
      return tempDiv.innerHTML;
    } else {

      const words = text.split(' ');
      if (words.length > wordLimit) {
        return words.slice(0, wordLimit).join(' ') + '...';
      }
      return text;
    }
  };

  const cleanHtml = (html) => {
    return DOMPurify.sanitize(html);
  };

  const renderText = (text , TextStyle) => {
    if (containsHTML(text)) {
      return (
        <div
          className={`${TextStyle ? TextStyle : "body-2  text-light-subtitle dark:text-dark-text"}`}
          dangerouslySetInnerHTML={{ __html: cleanHtml(text) }}
        />
      );
    } else {
      return (
        <p  className={`${TextStyle ? TextStyle : "body-2 text-light-subtitle dark:text-dark-text"}`}>
          {text}
        </p>
      );
    }
  };
export { truncateText, renderText ,truncateTextByLines };    